import { IMAGE_TYPE_URL } from '@/utils/common';
import format from '@/utils/format';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useMemo, useState } from 'react';
import defaultBanner from '@/assets/images/defaultBanner.png';

export interface IBanner {
  data: any;
  priority?: boolean;
}
const Banner = ({ data, priority }: IBanner) => {
  const { images } = data?.[0] || {};

  const url = useMemo(
    () =>
      format.convertToS3Link({
        type: IMAGE_TYPE_URL.BANNER,
        objectId: images?.[0]?.object_id,
        filename: images?.[0]?.filename || '',
      }),
    [data, images],
  );
  const [imgSrc, setImgSrc] = useState<string | StaticImport>(url);
  useEffect(() => {
    setImgSrc(url);
  }, [url]);
  return (
    <Link
      href={`${data?.[0]?.targetLink}`}
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      <div className="w-full relative h-full">
        <Image
          src={imgSrc}
          alt={'banner'}
          fill
          priority={priority}
          style={{ objectFit: 'contain' }}
          quality={60}
          sizes="(max-width: 768px) 50vw, (max-width: 1200px) 25vw, 30vw" // className="object-cover"
          onError={() => setImgSrc(defaultBanner)}
        />
      </div>
    </Link>
  );
};

export default Banner;
